import { getOpportunityDurationHours } from "./volunteerOpportunityDisplay";

/**
 * List totals for Volunteer Participants summary cards (current filtered rows).
 * @param {Array<{ opportunity_start_datetime?: string, opportunity_end_datetime?: string }>} rows
 */
export function summarizeVolunteerParticipantRows(rows) {
  let totalVolunteeringHours = 0;
  const list = Array.isArray(rows) ? rows : [];
  for (const row of list) {
    const hours = getOpportunityDurationHours(row?.opportunity_start_datetime, row?.opportunity_end_datetime);
    if (hours != null && hours > 0) totalVolunteeringHours += hours;
  }
  return {
    participantCount: list.length,
    totalVolunteeringHours: Math.round(totalVolunteeringHours * 10) / 10,
  };
}
